module.exports = __webpack_public_path__ + "static/media/verbo.35f8d311.svg";